import { render, staticRenderFns } from "./PcaPlotInfoModal.vue?vue&type=template&id=d33564ea&scoped=true"
import script from "./PcaPlotInfoModal.vue?vue&type=script&lang=js"
export * from "./PcaPlotInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33564ea",
  null
  
)

export default component.exports